import { render, staticRenderFns } from "./SearchBarResults.vue?vue&type=template&id=2a23ff76&scoped=true"
import script from "./SearchBarResults.vue?vue&type=script&lang=js"
export * from "./SearchBarResults.vue?vue&type=script&lang=js"
import style0 from "./SearchBarResults.vue?vue&type=style&index=0&id=2a23ff76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a23ff76",
  null
  
)

export default component.exports